import "vant/es/popup/style";
import _Popup from "vant/es/popup";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
Vue.use(_Popup);
export default {
  props: ['show', 'title'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    function handleClose() {
      emit('close');
    }
    return {
      handleClose: handleClose
    };
  }
};